// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  /* color: #cccccc; */
  font-family: 'Prompt', Helvetica;
  font-size: 20px;
  /* font-weight: 200; */
  font-weight: 700;
  color: #000000;
}

.recording {
  color: firebrick;
  padding-left: 1.2em;
}

.recording::before {
  content: '🔴';
  margin-right: 3px;
  animation: recording 600ms alternate infinite;
}
@keyframes recording {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
}

.actions {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.text-white {
  color: white;
}

/* Login Page */
.login-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.login-tabbar {
  display: flex;
  align-items: center;
}
.login-tab {
  padding: 10px 20px;
  border-bottom: solid 1px #DDDDDD;
  cursor: pointer;
}
.login-tab-selected {
  border: solid 1px #DDDDDD;
  border-bottom: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.login-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40vw;
  height: 50vh;
  border: solid 1px #DDDDDD;
  border-radius: 10px;
}
.login-content-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80vw;
  height: 60vh;
  border: solid 1px #DDDDDD;
  border-radius: 10px;
}
.login-content-no-border {
  border: none !important;
}
.login-form {
  display: flex;
  flex-direction: column;
}
.wx-qrcode {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 96%;
}

/* User Page */
.user-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.text-button {
  color: blue;
  cursor: pointer;
}

/* nextui */
.nextui-button-text {
  color: white !important;
}
input[type='text'] {
  color: black !important;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA,cAAc;AACd;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.header {\n  /* color: #cccccc; */\n  font-family: 'Prompt', Helvetica;\n  font-size: 20px;\n  /* font-weight: 200; */\n  font-weight: 700;\n  color: #000000;\n}\n\n.recording {\n  color: firebrick;\n  padding-left: 1.2em;\n}\n\n.recording::before {\n  content: '🔴';\n  margin-right: 3px;\n  animation: recording 600ms alternate infinite;\n}\n@keyframes recording {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0.2;\n  }\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n}\n\n.text-white {\n  color: white;\n}\n\n/* Login Page */\n.login-wrapper {\n  flex: 1 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.login-tabbar {\n  display: flex;\n  align-items: center;\n}\n.login-tab {\n  padding: 10px 20px;\n  border-bottom: solid 1px #DDDDDD;\n  cursor: pointer;\n}\n.login-tab-selected {\n  border: solid 1px #DDDDDD;\n  border-bottom: none;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n.login-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 40vw;\n  height: 50vh;\n  border: solid 1px #DDDDDD;\n  border-radius: 10px;\n}\n.login-content-mobile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 80vw;\n  height: 60vh;\n  border: solid 1px #DDDDDD;\n  border-radius: 10px;\n}\n.login-content-no-border {\n  border: none !important;\n}\n.login-form {\n  display: flex;\n  flex-direction: column;\n}\n.wx-qrcode {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 96%;\n}\n\n/* User Page */\n.user-wrapper {\n  flex: 1 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.text-button {\n  color: blue;\n  cursor: pointer;\n}\n\n/* nextui */\n.nextui-button-text {\n  color: white !important;\n}\ninput[type='text'] {\n  color: black !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
